import { Component, Input, OnInit, signal } from '@angular/core';
import { SideBarData } from './sidebar-data';
import { TokenService } from '../../services/token.service';
import { AuthorizationService } from '../../services/authorization.service';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {

  sideNavCollapsed = signal(false);
  @Input() set collapsed(val: boolean){
    this.sideNavCollapsed.set(val);
  };
  navDataDisplay: any[] = [];
  sideBarData = SideBarData;
  isAuthen: any;
  constructor(private tokenService: TokenService,
              private authorizationService: AuthorizationService
  ){
      this.isAuthen = this.tokenService.isAuthentication;
  }
  ngOnInit(): void {

    for (let nav of this.sideBarData) {
      // Nếu có subItems thì lọc từng cái theo quyền
      if (nav.subItems && nav.subItems.length > 0) {
        const permittedSubItems = nav.subItems.filter(sub => this.hasPermission(sub.name));
        if (permittedSubItems.length > 0) {
          // Push menu cha kèm subItems có quyền
          this.navDataDisplay.push({
            ...nav,
            subItems: permittedSubItems
          });
        }
      } else if (this.hasPermission(nav.name)) {
        // Nếu là menu không có subItem thì kiểm tra trực tiếp
        this.navDataDisplay.push(nav);
      }
    }
  }

  public hasPermission(functionName: string): boolean {
    return this.authorizationService.isAuthorizationByPerm(functionName);
  }

}
